import React from 'react';
import PropTypes from 'prop-types';
import {PayPalScriptProvider} from '@paypal/react-paypal-js';
import UserUtils from 'utils/user-utils';
import Config from '@/config/index';

export const INTENT_AUTHORIZE = 'authorize';
export const INTENT_TOKENIZE = 'tokenize';

export const getPayPalProviderOptions = () => ({
    clientId: Config.paypalClientIdUsd,
    currency: UserUtils.CURRENCY_TYPES.USD,
    intent: INTENT_AUTHORIZE,
    components: ['buttons'],
    vault: true,
    dataUserIdToken: Config.braintreeTokenizationKey,
});

const PayPal = ({children}) => {
    const initialOptions = getPayPalProviderOptions();

    return (
        // https://paypal.github.io/react-paypal-js/?path=/docs/example-paypalscriptprovider--default
        <PayPalScriptProvider deferLoading options={initialOptions}>
            {children}
        </PayPalScriptProvider>
    );
};

PayPal.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PayPal;
